import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#6496C8',
        secondary: '#64c896',
        accent: '#ffe168',
        error: '#c86464',
      },
    },
  },
});
